module.exports = __webpack_public_path__ + "media/images/icons/unsuccess_smile-dd05e46eb27f2ce9861827ffeb5e635f.svg";